import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_OBJECT, TRIGGER_TYPE, type TriggerLocation } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const EVENT_TEMPLATE_ID = '167';

// https://dataportal.zillowgroup.net/event-registry/4300
export const QUICK_RESPONSE_AVAILABLE_EVENT_TYPE_ID = '4300';
export const emitQuickResponseAvailableEvent = (user: ZrmClickstreamUserOrNull, triggerLocation: TriggerLocation) =>
  trackUserEvent({
    envelope: {
      event_type_id: QUICK_RESPONSE_AVAILABLE_EVENT_TYPE_ID,
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'quick_response_yes_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4301
export const QUICK_RESPONSE_NOT_AVAILABLE_EVENT_TYPE_ID = '4301';
export const emitQuickResponseNotAvailableEvent = (user: ZrmClickstreamUserOrNull, triggerLocation: TriggerLocation) =>
  trackUserEvent({
    envelope: {
      event_type_id: QUICK_RESPONSE_NOT_AVAILABLE_EVENT_TYPE_ID,
      event_type_version_id: '3',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'quick_response_no_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6425
export const QUICK_RESPONSE_ACCEPT_VOUCHERS_YES_EVENT_TYPE_ID = '6425';
export const emitQuickResponseAcceptVouchersYesEvent = (
  user: ZrmClickstreamUserOrNull,
  triggerLocation: TriggerLocation,
) =>
  trackUserEvent({
    envelope: {
      event_type_id: QUICK_RESPONSE_ACCEPT_VOUCHERS_YES_EVENT_TYPE_ID,
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'accept_vouchers_yes_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6426
export const QUICK_RESPONSE_ACCEPT_VOUCHERS_NO_EVENT_TYPE_ID = '6426';
export const emitQuickResponseAcceptVouchersNoEvent = (
  user: ZrmClickstreamUserOrNull,
  triggerLocation: TriggerLocation,
) =>
  trackUserEvent({
    envelope: {
      event_type_id: QUICK_RESPONSE_ACCEPT_VOUCHERS_NO_EVENT_TYPE_ID,
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'accept_vouchers_no_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
